import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { PvsCampaign } from 'models/interfaces/index';

export const GET_PVS_CAMPAIGN_QUERY = gql`
  query GetPvsCampaign($pvs_campaign_id: String!) {
    pvs: pvsCampaign(pvs_campaign_id: $pvs_campaign_id) {
      pvs_campaign_id
      tgrams_id
      advertiser {
        tgrams_id
        name
      }
      ad_server_campaign_id
      vertical_id
      vertical {
        vertical_id
        ad_server_id
        ad_server_vertical_id
        ad_server_name
        display_name
        is_active
        created_date
      }
      weight
      ad_server_name
      start_date
      end_date
      is_active
      last_sync_date
      is_dirty
      last_update_date
      created_date
    }
  }
`;

export const GET_CLIENT_PVS_CAMPAIGN_MODULE = gql`
  query GetPVSCampaignModule {
    campaignModule @client {
      pvs_campaign_id
      tgrams_id
      ad_server_campaign_id
      vertical_id
      weight
      ad_server_name
      start_date
      end_date
      is_active
      last_sync_date
      is_dirty
    }
  }
`;

export const SAVE_PVS_CAMPAIGN_MUTATION = gql`
  mutation SaveCampaign($campaign: PvsCampaignInput) {
    savePvsCampaign(campaign: $campaign) {
      pvs_campaign_id
      tgrams_id
      ad_server_campaign_id
      vertical_id
      weight
      ad_server_name
      start_date
      end_date
      is_active
      last_sync_date
      is_dirty
      last_update_date
    }
  }
`;

interface PvsCampaignContainerRenderProps {
  pvs: PvsCampaign;
  updateCampaignModule: (data: PvsCampaign) => any;
}
interface PvsCampaignContainerResults {
  pvs: PvsCampaign;
  updateCampaignModule: (data: PvsCampaign) => any;
}

interface PvsCampaignContainerProps {
  pvs_campaign_id: String;
  children: (props: PvsCampaignContainerRenderProps) => any;
}

const PvsCampaignContainer: React.FunctionComponent<PvsCampaignContainerProps> = ({
  pvs_campaign_id,
  children,
  ...props
}) => (
  <Query<PvsCampaignContainerResults>
    query={GET_PVS_CAMPAIGN_QUERY}
    fetchPolicy={'cache-and-network'} // req. b/c cache stores initial null res when creating a new campaign
    variables={{ pvs_campaign_id }}
  >
    {({ data: { pvs } = { pvs: {} as PvsCampaign }, loading, client }) => {
      if (loading) {
        return null;
      }
      // create a new pvs campaign if this one's empty
      if (pvs === null) {
        pvs = {} as PvsCampaign;
      }
      return (
        children &&
        children({
          ...props,
          pvs,
          updateCampaignModule: (campaignModule: any) => {
            return client.writeData({ data: { campaignModule } });
          }
        })
      );
    }}
  </Query>
);

export default PvsCampaignContainer;
